export const updateFunctionalityIndicatorsService = (fetch) => async (id, data) => {
  try {
    const response = await fetch({
      method: "put",
      url: `/api/v1/funcionamiento/indicadores/${id}`,
      body: data,
    });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
